import { Component } from '@angular/core';

@Component({
  selector: 'app-metodos-pago',
  templateUrl: './metodos-pago.component.html',
  styleUrls: [
    '../../../assets/css/footer-pages.css',
    './metodos-pago.component.css',
  ],
})
export class MetodosPagoComponent {}
